// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard .info-card {
  padding-bottom: 10px;
}

.dashboard .info-card h6 {
  font-size: 28px;
  color: #012970;
  font-weight: 700;
  margin: 0;
  padding: 0;
}

.dashboard .card-icon {
  font-size: 32px;
  line-height: 0;
  width: 64px;
  height: 64px;
  flex-shrink: 0;
  flex-grow: 0;
}

.dashboard .sales-card .card-icon {
  color: #4154f1;
  background: #f6f6fe;
}

.dashboard .revenue-card .card-icon {
  color: #2eca6a;
  background: #e0f8e9;
}

.dashboard .customers-card .card-icon {
  color: #ff771d;
  background: #ffecdf;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/card.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".dashboard .info-card {\n  padding-bottom: 10px;\n}\n\n.dashboard .info-card h6 {\n  font-size: 28px;\n  color: #012970;\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n}\n\n.dashboard .card-icon {\n  font-size: 32px;\n  line-height: 0;\n  width: 64px;\n  height: 64px;\n  flex-shrink: 0;\n  flex-grow: 0;\n}\n\n.dashboard .sales-card .card-icon {\n  color: #4154f1;\n  background: #f6f6fe;\n}\n\n.dashboard .revenue-card .card-icon {\n  color: #2eca6a;\n  background: #e0f8e9;\n}\n\n.dashboard .customers-card .card-icon {\n  color: #ff771d;\n  background: #ffecdf;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
